"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EndlessDungeonAdventureHandler = void 0;
const __1 = require("../..");
const EventType_1 = require("../../core/events/EventType");
const RoomArgs_1 = require("../../core/rooms/RoomArgs");
const RoomScript_1 = require("../../core/rooms/RoomScript");
const RoomType_1 = require("../../core/rooms/RoomType");
const Schedule_1 = require("../../core/Schedule");
const Registries_1 = require("../../core/state/Registries");
const Random_1 = require("../../utils/Random");
let EndlessDungeonAdventureHandler = class EndlessDungeonAdventureHandler {
    init(sequence, container, state) {
        const room = this.mkRoom(state);
        container.registerEventHandler(state.id, EventType_1.EventType.RoomCleared, Schedule_1.Schedule.Unlimited, new __1.TriggerAdventureEventHandlerArgs());
        container.registerEventHandler(state.id, EventType_1.EventType.RoomFailed, Schedule_1.Schedule.Unlimited, new __1.TriggerAdventureEventHandlerArgs());
        const roomId = container.addRoom(sequence, room);
        container.dispatch(sequence, state.id, new __1.EnterRoomActionArgs(roomId));
    }
    handleEvent(sequence, container, state, e) {
        switch (e.args.__typeName) {
            case "RoomCleared": {
                const room = this.mkRoom(state);
                const roomId = container.addRoom(sequence, room);
                container.dispatch(sequence, state.id, new __1.EnterRoomActionArgs(roomId));
                break;
            }
            case "RoomFailed": {
                container.failAdventure(sequence);
                break;
            }
            default:
                break;
        }
    }
    tick(sequence, container, state) { }
    mkRoom(state) {
        const count = (0, Random_1.random)(state.args.minEnemies, state.args.maxEnemies);
        const actors = [];
        for (let i = 0; i < count; i++) {
            actors.push((0, Random_1.randomElement)(state.args.toSpawn));
        }
        let roomType = (0, Random_1.randomElement)(Object.keys(RoomType_1.RoomType).filter(isNaN));
        while (roomType === "None") {
            roomType = (0, Random_1.randomElement)(Object.keys(RoomType_1.RoomType).filter(isNaN));
        }
        const room = new RoomArgs_1.RoomArgs([
            new RoomScript_1.BoundRoomScript("OnEnter_SpawnActors", {
                actors
            })
        ], [], [
            new RoomScript_1.BoundRoomScript("OnTick_ClearRoom_WhenEnemiesDefeated", {}),
            new RoomScript_1.BoundRoomScript("OnTick_FailRoom_WhenAlliesDefeated", {}),
        ], roomType);
        return room;
    }
};
EndlessDungeonAdventureHandler = __decorate([
    Registries_1.AdventureHandlers.register("EndlessDungeon")
], EndlessDungeonAdventureHandler);
exports.EndlessDungeonAdventureHandler = EndlessDungeonAdventureHandler;
